import type { FaireProductEntity } from "../../entity_types/product";

export const p_rjvzuaf9sv: FaireProductEntity = {
  token: "p_rjvzuaf9sv",
  type: "product",
  name: "Organic Cotton Tea towel - The Living Herbarium",
  brandToken: "b_u89gdyfh23",
  brandName: "Roomytown Inc",
  imageUrl:
    "https://cdn.faire.com/fastly/919b0a967c31f1415263583cb9a61a306f5eb42f9a80c108c0ad8a48364872d7.jpeg",
  galleryImageUrls: [],
  priceDollars: 9,
  description:
    "This 100% Organic Cotton Tea Towel showcases a collection of floral illustrations taken from an 18th-century herbarium created using nature printing (circa 1733). Each botanical specimen has been delicately restored and adapted by Roomytown’s design team, then paired with a vintage weave-pattern background reproduced from 19th-century French textile samples from the historic Robert Maison company. The result is an elegant, refined composition that feels both timeless and distinctly botanical.\n\nPrinted on soft yet durable organic cotton, this tea towel brings a touch of art and history into the everyday—perfect for kitchens that celebrate thoughtful design and natural beauty. It comes neatly folded and finished with a fabric ribbon, with an included hanging loop for easy display. Machine washable for effortless, everyday use.",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-24T21:40:45.308Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
